import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

const leftItems = [
  'Discorsi motivazionali',
  '“Devi solo volerlo”',
  'Piani perfetti su carta',
  'Obiettivi enormi e lontani',
  'Vergogna per i fallimenti',
  'Teoria infinita',
]

const rightItems = [
  'Sistema concreto',
  '“Partiamo da dove sei”',
  'Micro missioni quotidiane',
  'Progressione visibile',
  'Analisi senza giudizio',
  'Azione + recupero',
]

export default function DifferenceSection() {
  const sectionRef = useRef(null)
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' })

  return (
    <section ref={sectionRef} id="differenza" className="relative w-full py-12 md:py-18 px-4" style={{ background: '#050510' }}>
      <div className="max-w-5xl mx-auto">
        <motion.div className="text-center mb-14"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-nerd-white mb-4">
            La{' '}
            <span className="text-gradient">differenza.</span>
          </h2>
          <p className="text-nerd-gray text-base md:text-lg max-w-xl mx-auto">
            Non è che non ci provi. È che stai usando gli strumenti sbagliati.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Left: what doesn't work */}
          <motion.div
            className="manga-panel rounded-xl p-6 md:p-8 relative"
            initial={{ opacity: 0, x: -40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 rounded-full bg-nerd-red/10 border border-nerd-red/30 flex items-center justify-center">
                <span className="text-nerd-red text-sm">✕</span>
              </div>
              <h3 className="font-display text-lg font-bold text-nerd-white">Quello che non funziona</h3>
            </div>
            <ul className="space-y-4">
              {leftItems.map((item, i) => (
                <motion.li
                  key={item}
                  className="flex items-center gap-3 text-nerd-gray/70 text-sm"
                  initial={{ opacity: 0, x: -15 }}
                  animate={isInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.4, delay: 0.4 + i * 0.08 }}
                >
                  <span className="w-5 h-5 rounded-full border border-nerd-red/30 flex items-center justify-center flex-shrink-0">
                    <span className="text-[10px] text-nerd-red">✕</span>
                  </span>
                  {item}
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Right: what works */}
          <motion.div
            className="manga-panel rounded-xl p-6 md:p-8 relative"
            style={{ borderColor: 'rgba(0,212,255,0.25)' }}
            initial={{ opacity: 0, x: 40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.3 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 rounded-full bg-nerd-blue/10 border border-nerd-blue/30 flex items-center justify-center">
                <span className="text-nerd-blue text-sm">✓</span>
              </div>
              <h3 className="font-display text-lg font-bold text-nerd-white">Quello che funziona</h3>
            </div>
            <ul className="space-y-4">
              {rightItems.map((item, i) => (
                <motion.li
                  key={item}
                  className="flex items-center gap-3 text-nerd-gray text-sm"
                  initial={{ opacity: 0, x: 15 }}
                  animate={isInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.4, delay: 0.5 + i * 0.08 }}
                >
                  <span className="w-5 h-5 rounded-full border border-nerd-blue/30 flex items-center justify-center flex-shrink-0">
                    <span className="text-[10px] text-nerd-blue">✓</span>
                  </span>
                  {item}
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>

        <motion.div className="text-center mt-10"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ delay: 1.2 }}
        >
          <p className="text-nerd-gray/60 text-sm italic">
            “Non serve più motivazione. Serve un sistema che funzioni con il tuo cervello, non contro.”
          </p>
        </motion.div>
      </div>
    </section>
  )
}
